var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"switch",class:{
    'switch--disabled': _vm.disabled,
    'switch--error': _vm.error,
    'switch--checked': _vm.checked,
    'switch--reverse': _vm.reverse,
    'switch--full-width': _vm.fullWidth,
  }},[_c('input',{attrs:{"type":"checkbox","disabled":_vm.disabled},domProps:{"checked":_vm.checked},on:{"change":function($event){return _vm.$emit('change', $event.target.checked)}}}),_c('span',{staticClass:"switch__slider"}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }